<div class="container-fluid bgcolor2">
    <form autocomplete="off" novalidate>
        <div class="row">
            <div class="col-sm-12 row align-items-center">
                <div
                    class=" card-header mt-2 mb-0 mb-0 example-full-width shadow-sm col-sm-12 card  text-black bgcolor ">
                    <div class='row pr-0 mr-0'>
                        <div class=" col-sm-3  ">
                            <mat-form-field appearance="outline" class="example-full-width  " >
                                <mat-label>{{'header.academic-session-master.titleList.StartYear' | translate }}
                                </mat-label>
                                <mat-select required #select1
                                    placeholder="{{'header.town-master.titleList.Country' | translate }}"
                                    class="colorblack">
                                    <mat-option value="abc"> abc</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class=" col-sm-3  ">
                            <mat-form-field appearance="outline" class="example-full-width  " >
                                <mat-label>{{'header.academic-session-master.titleList.EndYear' | translate }}
                                </mat-label>
                                <mat-select required #select1
                                    placeholder="{{'header.town-master.titleList.State' | translate }}"
                                    class="colorblack">
                                    <mat-option value="abc"> abc</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class=" col-sm-3  ">
                            <mat-form-field appearance="outline" class="example-full-width" >
                                <mat-label>{{'header.academic-session-master.titleList.SessionName' | translate }}
                                </mat-label>
                                <mat-select required #select1
                                    placeholder="{{'header.town-master.titleList.Division' | translate }}"
                                    class="colorblack">
                                    <mat-option value="abc"> abc</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class=" col-sm-3  ">
                            <mat-form-field appearance="outline" class="example-full-width" >
                                <mat-label>{{'header.academic-session-master.titleList.PreviousSession' | translate }}
                                </mat-label>
                                <mat-select required #select1
                                    placeholder="{{'header.town-master.titleList.District' | translate }}"
                                    class="colorblack">
                                    <mat-option value="abc"> abc</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class=" col-sm-3  ">
                            <mat-form-field appearance="outline" class="example-full-width" >
                                <mat-label>{{'header.academic-session-master.titleList.AdmissionOpen' | translate }}
                                </mat-label>
                                <mat-select required #select1
                                    placeholder="{{'header.town-master.titleList.Division' | translate }}"
                                    class="colorblack">
                                    <mat-option value="abc"> abc</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class=" col-sm-3  ">
                            <mat-form-field appearance="outline" class="example-full-width  " >
                                <mat-label> {{'header.academic-session-master.titleList.SessionStatus' | translate }}
                                </mat-label>
                                <mat-select required #select1
                                    placeholder=" {{'header.town-master.titleList.Is Active' | translate }}"
                                    class="colorblack">
                                    <mat-option value="abc"> abc</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class=" col-sm-2 mt-2"> <button type="button"
                                class=" btn btn-sm  example-full-width text-white"> {{
                                'header.academic-session-master.titleList.Save' | translate }} </button> </div>
                        <div class=" col-sm-2 mt-2"> <button type="button"
                                class=" btn btn-sm  example-full-width text-white"> {{
                                'header.academic-session-master.titleList.Back' | translate }} </button> </div>
                        <div class="col-sm-6 mt-2"></div>
                    </div>
                </div>
            </div>
            <div class="row col-sm-12">
                <div class="col-sm-12 pt-3">
                    <div class="example-container mat-elevation-z8">
                        <mat-table #table [dataSource]="dataSource" matSort>
                            <!-- Position Column -->
                            <ng-container matColumnDef="SessionYear">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> {{
                                    'header.academic-session-master.table.SessionYear' | translate }} </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.SessionYear}} </mat-cell>
                            </ng-container> <!-- Name Column -->
                            <ng-container matColumnDef="SessionName">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> {{
                                    'header.academic-session-master.table.SessionName' | translate }} </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.SessionName}} </mat-cell>
                            </ng-container> <!-- Weight Column -->
                            <ng-container matColumnDef="AdmissionStatus">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                    {{'header.academic-session-master.table.AdmissionStatus' | translate }}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.AdmissionStatus}} </mat-cell>
                            </ng-container> <!-- Symbol Column -->
                            <ng-container matColumnDef=" SessionStatus">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                    {{'header.academic-session-master.table.SessionStatus' | translate }}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element. SessionStatus}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="Action">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> {{'header.town-master.table.Action'
                                    | translate }} </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.Action}} <i matTooltip="View"
                                        class="fas fa-eye"></i> </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                        </mat-table>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>